<div class="overlay-content">
  <ng-content></ng-content>
</div>
